import { MezziService } from './../services/mezzi.service';
import { IMezzo } from './../interfaces/IMezzo';
import { Component, OnInit } from '@angular/core';
import * as Enum from '../utils/enums'
import { TranslateService } from '@ngx-translate/core';
import { DialogService, MenuItem } from 'primeng/api';
import { AlertUtil } from '../utils/alert-util';
import * as Constants from '../utils/constants';
import { MezzoModalComponent } from '../mezzo-modal/mezzo-modal.component';
import { ICommessa } from '../interfaces/ICommessa';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { CommessaService } from '../services/commessa.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-mezzi',
  templateUrl: './mezzi.component.html',
  styleUrls: ['./mezzi.component.css']
})
export class MezziComponent implements OnInit {

  mezzi: IMezzo[]  // table data source
  rowSelected: boolean = false    //determines whether one commessa row has been clicked
  mezzo: IMezzo
  isAggiudicatario: boolean
  commesse: ICommessa[]

  itemsReports: MenuItem[];

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  constructor(private mezziService: MezziService,
    private translate: TranslateService,
    private dialogService: DialogService,
    private alertUtil: AlertUtil,
    private commessaService: CommessaService) { }

  ngOnInit() {
    this.isAggiudicatario = false
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO || userRole == Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isAggiudicatario = true
    }
    setTimeout(() => {
      this.getAllMezzi()
      this.getAllCommesse()
    }, 0);
  }

  /**
   * get all mezzi
   * @param payload request payload
   * @param nameForReports name of reports
   */
  getAllMezzi(payload?: any) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(payload != null ? payload : {})
    this.mezziService.getAllMezzi(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.mezzi = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  onCreateMezzo() {
    this.mezzo = null
    this.openMezzoModal(false)
  }

  onUpdateMezzo(mezzoForUpdate: IMezzo) {
    this.mezzo = mezzoForUpdate
    this.openMezzoModal(true)
  }

  /**
   * open new mezzo modal
   */
  openMezzoModal(isUpdate: boolean) {
    let modalTitle = "LBL_NEW_MEZZO"
    if (isUpdate) {
      modalTitle = "LBL_UPDATE_MEZZO"
    }
    //get header translation
    this.translate.get(modalTitle).subscribe(res => {
      let mezzo = this.mezzo
      //open mezzo modal
      let mezzoModal = this.dialogService.open(MezzoModalComponent, {
        data: {
          mezzo: mezzo,
          fromFiliera: false
        },
        header: res,
        width: '50%'
      })

      // refresh mezzi when modal is closed and newMezzo is created
      mezzoModal.onClose.subscribe((mezzoObj) => {
        if (mezzoObj) {
          this.getAllMezzi()
        }
      })
    })
  }

  /**
   * commessa filtro
   */
  onCommessaClicked(event: any) {
    if (event && event.value.Id > 0) {
      let payload: any = {
        commessa: {
          Id: event.value.Id
        }
      }
      this.getAllMezzi(payload)
    } else {
      this.getAllMezzi()
    }
  }

  /**
   * retrieve all commesse
   */
  getAllCommesse() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.commessaService.getAllCommesse(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.setCommessaDefault();
          response.data.forEach((commessa: ICommessa) => {
            this.commesse.push(commessa)
          });

        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * push commessa Tutte in array
   */
  private setCommessaDefault() {
    this.commesse = [];
    let commessaDefault: ICommessa = {
      Id: 0,
      Codice: "Tutte",
      Nome: "",
      Descrizione: "",
      Data_inizio_lavori: "",
      Data_fine_lavori: "",
      Responsabile: "",
      GUID_autore: "",
      CUP: "",
      CIG: "",
      Codice_contratto: "",
      Censita: true,
      Cantieri: null,
      Aggiudicatario: null
    };
    this.commesse.push(commessaDefault);
  }

  /**
   * callback fired when stop activity for mezzo is clicked
   * @param mezzo 
   */
  onTerminaAttivitaMezzo(mezzo: IMezzo) {
    // ask for stop activity confirmation
    this.alertUtil.showConfirmationAlert("LBL_STOP_ACTIVITY_CONFIRMATION_MEZZO_CRUD", null, null, null, null, () => {
      Loading.isLoading = true
      let requestBuilder = new RequestBuilder({ Id: mezzo.Id })
      // Modifica del 26/11/2024 - Nuovo servizio di delete Mezzo
      this.mezziService.delete(requestBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response.data) {
            // refresh accessi for cantiere
            this.alertUtil.showAlert("LBL_STOP_ACTIVITY_SUCCESS", null, null, null, () => {
              this.getAllMezzi()
            })
          }
          else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log("ERROR: " + response.error.Stack)
          }
          else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        })
    })
  }


  /**
   * for field reports
   * @param menu 
   * @param event 
   */
  onClickReports(menu, event: any) {
    this.optionsReport()
    menu.toggle(event)
  }

  /**
   * set options report
   */
  private optionsReport() {
    this.translate.get(["LBL_REPORT_MEZZI_CENSITI", "LBL_REPORT_MEZZI_APPROVATI",]).subscribe(res => {
      this.itemsReports = [
        {
          label: res["LBL_REPORT_MEZZI_CENSITI"], icon: '', command: () => {
            this.generateReport(res["LBL_REPORT_MEZZI_CENSITI"], true);
          }
        },
        {
          label: res["LBL_REPORT_MEZZI_APPROVATI"], icon: '', command: () => {
            this.generateReport(res["LBL_REPORT_MEZZI_APPROVATI"], false);
          }
        }
      ];
    })
  }

  /**
   * call service and downloadFile
   */
  generateReport(fileName: string, censiti: boolean) {
    if (censiti) {
      this.reportMezziCensiti(fileName)
    } else {
      this.reportMezziValidati(fileName)
    }
  }


  /**
   * download zip file
   * @param response response from service
   * @param type type of file
   * @param name name of file
   */
  downloadFile(response: any, type: string, name: string) {
    let fileType = ""
    let stringDecoded: any
    //switch type of file and set fileType and string decoded
    switch (type) {
      case Enum.FILE_TYPE_ENUM.XLS:
        fileType = "application/vnd.ms-excel;charset=utf-8"
        stringDecoded = this.s2ab(atob(response))
        break
      case Enum.FILE_TYPE_ENUM.XLSX:
        fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        stringDecoded = this.s2ab(atob(response))
        break
      default: //case Enum.FILE_TYPE_ENUM.TXT:
        fileType = "text/plain;charset=utf-8"
        stringDecoded = atob(response)
    }

    let blob = new Blob([stringDecoded], {
      type: fileType
    })
    FileSaver.saveAs(blob, name)
  }

  private s2ab(s: any) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  /**
   * get mezzi validati
   * @param nameForReports name of reports
   * @param payload request payload
   */
  reportMezziValidati(nameForReports: string, payload?: any) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(payload != null ? payload : {})
    this.mezziService.reportMezziValidati(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          this.downloadFile(response, Enum.FILE_TYPE_ENUM.XLSX, nameForReports)
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * get mezzi censiti
   * @param nameForReports 
   * @param payload 
   */
  reportMezziCensiti(nameForReports: string, payload?: any) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(payload != null ? payload : {})
    this.mezziService.reportMezziCensiti(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          this.downloadFile(response, Enum.FILE_TYPE_ENUM.XLSX, nameForReports)
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
}
